import { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const ScheduledIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <path
        d="M1,8V27a4,4,0,0,0,4,4H19a1,1,0,0,0,0-2H5a2,2,0,0,1-2-2V12H29v5a1,1,0,0,0,2,0V8a4,4,0,0,0-4-4H24V1a1,1,0,0,0-2,0V4H10V1A1,1,0,0,0,8,1V4H5A4,4,0,0,0,1,8Z"
        fill={color}
      />
      <path
        data-color="color-2"
        d="M17,24a1,1,0,0,1,0-2h6V18a1,1,0,0,1,1.64-.769l6,5a1,1,0,0,1,0,1.538l-6,5A1,1,0,0,1,24,29a.989.989,0,0,1-.424-.095A1,1,0,0,1,23,28V24Z"
        fill={color}
      />
    </svg>
  );
};
